export default __webpack_public_path__ + "static/media/InfluencerBit-New-Final-Logo-white.50bd346c.png";